import {refreshTheme} from "../../Theme/lib/refreshTheme";
import {reflectPreference} from "../../Theme/lib/reflectPreference";
import {Mode} from "../../Theme";

export const updateThemeBrawser = (currentTheme: Mode) => {
    refreshTheme(currentTheme)
    reflectPreference(currentTheme)
}
